import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { categoryTypeService } from "../../../services/categoryTypeService";

// New DeleteConfirmationPopup component
const DeleteConfirmationPopup = ({ onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-sm">
        <h2 className="text-xl font-bold mb-2">Delete Category Type</h2>
        <p className="text-gray-600 text-center mb-6">
          Are you sure you want to delete this category type? This action can't
          be undone.
        </p>
        <div className="flex gap-4 w-full">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const StyledCategoryTypeDropdown = ({
  types,
  value,
  onChange,
  onCategoryTypeDeleted,
}) => {
  const [showDeleteOption, setShowDeleteOption] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [typeIdToDelete, setTypeIdToDelete] = useState(null);

  const handleDeleteClick = async (e, typeId) => {
    e.stopPropagation();
    setTypeIdToDelete(typeId);
    setShowDeletePopup(true); // Show the custom delete confirmation popup
  };

  const confirmDelete = async () => {
    if (typeIdToDelete) {
      try {
        setIsDeleting(true);
        await categoryTypeService.deleteCategoryType(typeIdToDelete);
        if (typeof onCategoryTypeDeleted === "function") {
          onCategoryTypeDeleted(typeIdToDelete);
        }
      } catch (error) {
        console.error("Failed to delete category type:", error);
        alert("Failed to delete category type. Please try again.");
      } finally {
        setIsDeleting(false);
        setShowDeletePopup(false); // Close the popup after deletion
        setTypeIdToDelete(null);
      }
    }
  };

  return (
    <div className="relative">
      <div
        className="w-full p-2 border rounded-md cursor-pointer"
        onClick={() => setShowDeleteOption(!showDeleteOption)}
      >
        {value && types.length > 0
          ? types.find((type) => type._id === value)?.typeName
          : "Select Category Type"}
      </div>
      {showDeleteOption && types.length > 0 && (
        <ul className="absolute w-full bg-white border rounded-md shadow-lg z-10">
          {types.map((type) => (
            <li
              key={type._id}
              className="flex justify-between p-2 hover:bg-gray-100"
              onClick={() => {
                if (type._id) {
                  onChange(type._id);
                }
                setShowDeleteOption(false);
              }}
            >
              <span>{type.typeName}</span>
              <button
                onClick={(e) => handleDeleteClick(e, type._id)}
                disabled={isDeleting}
                className="text-red-500 hover:text-red-700"
              >
                X
              </button>
            </li>
          ))}
        </ul>
      )}
      {showDeletePopup && (
        <DeleteConfirmationPopup
          onClose={() => setShowDeletePopup(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
};

export default StyledCategoryTypeDropdown;
